import { SNACKBAR_TYPE } from "../../constants/notificationType";
import BaseNotificationController from "../../BaseNotificationController";

class SnackbarController extends BaseNotificationController {
  /**
   * DESNOTE: snackbarData object has fields:
   *    displayTime - optional, number
   *    message - required, string
   *
   * Example: snackbarData: {
   *   displayTime: 5000
   *   message: "Hello!"
   * }
   */
  showSuccess = snackbarData =>
    this.create(SNACKBAR_TYPE.SUCCESS, snackbarData);

  showAlert = snackbarData => this.create(SNACKBAR_TYPE.ALERT, snackbarData);

  showInfo = snackbarData => this.create(SNACKBAR_TYPE.INFO, snackbarData);

  showWarning = snackbarData =>
    this.create(SNACKBAR_TYPE.WARNING, snackbarData);
}

export default SnackbarController;
